import React, { useContext, useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { UserContext } from "../reuseableComponents/auth/UserContext";
import SecureModuleIndex from "../secure/SecureModuleIndex";
import bgImage from "../../images/loginBackgrounds/unsplash.png";
import bgBottom from "../../images/loginBackgrounds/bottom-mtn.png";
import mtnLogo from "../../images/DEQ_Logos/Mountain-Logo-Utah-DW-2.svg";
import { Button, Modal, ModalTitle, ModalContent, ModalFooter } from "@utahdts/utah-design-system";
import { useMutation } from "@apollo/client";
import { REQUEST_ACCESS } from "../../queries/publicQrys/UserAccessQrys";
import RequestAccessSuccess from "./RequestAccessSuccess";

const StaffAccessForm = (props) => {
  const [accountName, setAccountName] = useState("");
  const [accountNameError, setAccountNameError] = useState(false);
  const [section, setSection] = useState("");
  const [managerName, setManagerName] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const [requestAccess, { data, reset }] = useMutation(REQUEST_ACCESS, {
    onError: (error) => {
      setErrorMessage(`${error.name}: ${error.message}`);
    },
    onCompleted: (data) => {
      if (data.requestAccess === false) {
        setErrorMessage("An unknown error occurred. Please try again.");
      } 
    }
  });

  const { user } = useContext(UserContext);

  const buttonStyle = {
    margin: "10px",
    borderRadius: "20px",
    cursor: "pointer",
    fontSize: "16px",
  };

  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: "50px"
  };

  const bottomSectionStyle = {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    backgroundImage: `url(${bgBottom})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    padding: "60px 0",
  };

  const bottomContentStyle = {
    textAlign: "left",
    maxWidth: "80%",
    color: "#157995",
    fontSize: "18px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  };

  const formStyle = {
    width: "500px",
    margin: "20px 0",
    marginLeft: "200px",
    alignItems: "flex-start",
  };

  const formGroupStyle = {
    paddingBottom: "20px"
  };

  const handleCancelClick = (event) => {
    window.location.href = ('/public/request-access')
  }

  const handleCloseErrorModal = () => {
    setErrorMessage(null);
    reset();
  }

  const handleAccountNameChange = (e) => {
    const value = e.target.value;
    setAccountName(value);
  
    // Check if the input is valid
    if (value.trim() === "") {
      setAccountNameError(true); // Set error if the field is empty
    } else {
      setAccountNameError(false); // Clear error if the field is valid
    }
  };

  const onSubmit = () => {
    if(accountName === "") {
      setAccountNameError(true);
      return;
    }

    const userRequest = {
      umd_id: user.umdId,
      accountName: accountName,
      section: section,
      manager: managerName,
      requestAccessType: "staff"
    }
    
    requestAccess({
      variables: {
        input: userRequest,
      },
    });
  }

  return (
    <>
      {user.isPublic ? (
        <Row>
          <Col>
            <div id="landingPageContainer">
              <div style={{ display: "flex", flexDirection: "column", width: "100%", maxWidth: "100vw", backgroundImage: `url(${bgImage})`, backgroundRepeat: "no-repeat", backgroundSize: "cover" }}>
                <div style={{ paddingBottom: "80px", alignItems: "center" }}>
                  <div style={{ textAlign: "center", maxWidth: "60%", margin: "auto" }}>
                    <img src={mtnLogo} alt='Mountain Logo' style={{ maxWidth: "100%", objectFit: "contain" }} />
                  </div>
                  <br />
                  <p style={{ maxWidth: "80%", textAlign: "center", fontWeight: "bold", fontSize: "42px", color: "#fff", margin: "auto", objectFit: "contain" }}>
                    Request Access Staff
                  </p>
                  <br />
                </div>
                <div style={bottomSectionStyle}>
                  {errorMessage && (
                    <div className="utah-design-system">
                      <Modal
                        ariaLabelledBy="access-request-failure"
                        className="modal--medium center"
                        id="modal-example"
                      >
                        <ModalTitle id="access-request-failure">
                            Something went wrong
                        </ModalTitle>
                        <ModalContent>
                            {errorMessage}
                        </ModalContent>
                        <ModalFooter className="flex float-right flex-wrap">
                          <Button onClick={handleCloseErrorModal}>Close</Button>
                        </ModalFooter>
                      </Modal>
                    </div>
                  )}
                {data?.requestAccess === true ? (<RequestAccessSuccess/>) : (
                  <div style={bottomContentStyle}>
                    <div style={buttonContainerStyle}>
                      
                      <Form style={formStyle}>
                        <Form.Group controlId="accountName" style={formGroupStyle}>
                          <Form.Label style={{ display: 'block', textAlign: 'left' }}>Account Name:</Form.Label>
                          <Form.Control
                            type="text"
                            value={accountName}
                            onChange={handleAccountNameChange}
                            isInvalid={accountNameError}
                          />
                          <Form.Control.Feedback type="invalid">
                            Account Name is required.
                          </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group controlId="section" style={formGroupStyle}>
                          <Form.Label style={{ display: 'block', textAlign: 'left' }}>Section:</Form.Label>
                          <Form.Control
                            type="text"
                            value={section}
                            onChange={(e) => setSection(e.target.value)}
                          />
                        </Form.Group>

                        <Form.Group controlId="managerName" style={formGroupStyle}>
                          <Form.Label style={{ display: 'block', textAlign: 'left' }}>Manager Name:</Form.Label>
                          <Form.Control
                            type="text"
                            value={managerName}
                            onChange={(e) => setManagerName(e.target.value)}
                          />
                        </Form.Group>

                        <div className="utah-design-system" style={buttonContainerStyle}>
                          <Button appearance="outlined" size="large" color="primary" style={ buttonStyle } onClick={() => { handleCancelClick() }}>
                            Cancel
                          </Button>
                          <Button appearance="solid" size="large" color="primary" style={ buttonStyle } onClick={() => { onSubmit() }} >
                            Submit
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </div>
                )}
                </div>
              </div>
            </div>
          </Col>
        </Row>
      ) : (
        <SecureModuleIndex />
      )}
    </>
  );
};
export default StaffAccessForm;
